// 云环境实例配置项
export const envInsItemConfig = {
    zone: {
        name: '可用区',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'CloudOS']
    },
    charge_type: {
        name: '计费类型',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'CloudOS']
        // envs: ['Aliyun', 'Qcloud', 'HuaweiCloud', 'HCSO']
    },
    compute_res_type: {
        name: '计算资源',
        envs: ['FusionCompute']
    },
    res_group: {
        name: '资源组',
        envs: ['Azure']
    },
    instance_type: {
        name: '实例类型',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute']
    },
    instance_name: {
        name: '实例名称',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute']
    },
    instance_alias: {
        name: '实例别名',
        envs: ['CloudOS']
    },
    image: {
        name: '镜像',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute']
    },
    node: {
        name: '节点',
        envs: ['CloudOS']
    },
    host_name: {
        name: 'HostName',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute']
    },
    system_disk: {
        name: '系统盘',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute'],
        config: {
            Aliyun: 500,
            VMware: 2000,
            Qcloud: 500,
            HuaweiCloud: 500,
            HCSO: 500,
            Aws: 2000
        }
    },
    data_disk: {
        name: '数据盘',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'FusionCompute']
    },
    network: {
        name: '网络',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute']
    },
    security_group: {
        name: '安全组',
        envs: ['Aliyun', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure']
    },
    floating_ip: {
        name: '弹性IP',
        envs: ['Aliyun', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'HuaweiCloud', 'HCSO', 'Aws', 'Qcloud']
    },
    band_width: {
        name: '带宽',
        envs: ['Aliyun', 'Qcloud', 'PowerVC']
    },
    login_type: {
        name: '登录方式',
        envs: ['Aliyun', 'VMware', 'Qcloud', 'OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS', 'PowerVC', 'HuaweiCloud', 'HCSO', 'Aws', 'Azure', 'FusionCompute'],
        config: {
            Aliyun: [{
                name: '密码',
                value: 'ByPassword'
            }],
            VMware: [{
                name: '密码',
                value: 'ByPassword'
            }],
            Qcloud: [{
                name: '密码',
                value: 'ByPassword'
            }],
            Nine9Cloud: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            'Nine9Cloud-Admin': [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            OpenStack: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            'OpenStack-Admin': [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            ESCloud: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            'ESCloud-Admin': [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            CloudOS: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            HuaweiCloud: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            HCSO: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }],
            FusionCompute: [{
                name: '密码',
                value: 'ByPassword'
            }],
            Aws: [{
                name: '密钥',
                value: 'ByKeypair'
            }],
            PowerVC: [{
                name: '密钥',
                value: 'ByKeypair'
            }],
            Azure: [{
                name: '密码',
                value: 'ByPassword'
            }, {
                name: '密钥',
                value: 'ByKeypair'
            }]
        }
    },
    storage_zone: {
        name: '存储可用区',
        envs: ['OpenStack', 'Nine9Cloud', 'Nine9Cloud-Admin', 'CloudOS', 'ESCloud', 'ESCloud-Admin']
    }
}
// 认证信息常量
export const authentMaps = {
    noAuth: '待认证',
    authing: '认证中',
    authSucceed: '认证成功',
    authFiled: '认证失败'
}

// 优惠券和现金券的状态映射
export const couponStatusMaps = {
    coupon_available: '可用',
    coupon_used: '已使用',
    coupon_unused: '未使用',
    coupon_unavailable: '已过期',
    coupon_invalid: '已作废',
    coupon_undistributed: '未分发',
    deductCoupon_exhausted: '耗尽'
}
/**
 *  现金券、优惠券:用户来说有已使用、未使用、已过期,已作废
 *   */

// 用户
export const couponStatusList = [
    { value: 'coupon_used', label: '已使用' },
    { value: 'coupon_unused', label: '未使用' },
    { value: 'coupon_invalid', label: '已作废' },
    { value: 'coupon_unavailable', label: '已过期' }
]
